import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dipature-assis',
  templateUrl: './dipature-assis.component.html',
  styleUrls: ['./dipature-assis.component.css']
})
export class DipatureAssisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
